import React from "react";
import PropTypes from "prop-types";
import { Bubble } from "@nivo/circle-packing";

import "./index.scss";

class CirclePacking extends React.PureComponent {
  state = {
    labelSkipRadius: 22,
    prevNodeId: "root"
  }
  render() {
    const { root } = this.props;
    const lowerNodeValue = 1, upperNodeValue = 22;
    const width = window.innerWidth < 700 ? window.innerWidth - 60 : 600;
    return (
      <div id="ori-circle-packing-chart" style={{ width: `${width}px` }}>
        <Bubble
          root={root}
          width={width}
          height={600}
          margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
          identity={id => {
            if (typeof id.name === "number") return id.name.toString(); //BubbleHTML needs all names to be a string
            return `${id.name}`;
          }}
          colors={d => {
            if (d.name === "root") return "#e0f6ff";
            if (typeof d.name === "number") return "#c4edfe";
            return "#009bfa";
          }}
          colorBy="name"
          label={d => {
            if (d.id === "root") return "";
            return `${d.id.split(/\s/g).join("\n")}`;
          }}
          labelSkipRadius={this.state.labelSkipRadius}
          labelTextColor="black"
          tooltip={({ id, value, color }) => {
            const isNum = id.match(/^\d+$/) !== null;
            if (id === "root") return <strong style={{ color }}>Root</strong>;
            return (
              <strong style={{ color }}>
                {!isNum ? `Intent Name ${id}: ${value}` : `Group ${id}`}
              </strong>
            );
          }}
          theme={{
            tooltip: {
              container: {
                background: "#333"
              }
            },
            labels: {
              text: {}
            }
          }}
          onClick={node => {
            const { id, depth } = node;
            const { labelSkipRadius, prevNodeId } = this.state;
            if (depth === 0 && labelSkipRadius !== upperNodeValue)
              this.setState({ labelSkipRadius: upperNodeValue, prevNodeId: id });
            else if (depth >= 1 && labelSkipRadius !== lowerNodeValue)
              this.setState({ labelSkipRadius: lowerNodeValue, prevNodeId: id });
            else if (depth >= 1 && labelSkipRadius !== upperNodeValue && prevNodeId === id)
              this.setState({ labelSkipRadius: upperNodeValue, prevNodeId: "root" });
            else if (depth >= 1 && labelSkipRadius !== upperNodeValue && prevNodeId !== id)
              this.setState({ prevNodeId: id });
          }}
        />
      </div>
    );
  }
}

CirclePacking.propTypes = {
  root: PropTypes.object.isRequired
};

export default CirclePacking;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/analytics/queryanalytics/components/circlepacking/index.js